import { Box, Button, Typography, Modal, Grid, CardContent, Card } from "@mui/material";
import React, { useEffect, useState } from "react";
import AddPost from "./AddPost/AddPost";
import { getJobPosts, removeJobPost } from "../../api/apiCall";
import { confirmDialog } from "../../components/ConfirmDialog/confirmDialog";
import { useAuth } from "../../auth/auth";
import { format } from "date-fns";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { style } from "../Admin/Dashboard/style";

const JobListings = () => {
    const {state} = useAuth();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [posts, setPosts] = useState<any>([]);

    const getPosts = async () => {
        const response = await getJobPosts(state.user?.token, 1);
        setPosts(response);
    }

    useEffect(() => {
        getPosts();
    }, []);

    const deletePost = async (postId: any, title: any) => {
        confirmDialog({
            title: `Are you sure you want to delete ${title}?`,
            onOk: async () => {
                const response = await removeJobPost(state.user?.token, postId);
                if(response) {
                    toast.error('Deleted job post successfully');
                    getPosts();
                }
            },
            okButtonProps: { danger: true },
            okText: 'YES',
            cancelText: 'NO',
            centered: true
        });
    }

    const goToInterests = async (postId: any) => {
        navigate('/pace-team/resourcing/job-listings/interested-workers', {
            state: { postId: postId }});
    };

    return (
        <Box
            sx={{
                minHeight: "100vh",
                bgcolor: "#f2f5fc"
            }}>
            <Box sx={{ p: 4 }}>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "space-between"
                    }}>
                    <Typography
                        variant="h5"
                        sx={{
                            fontWeight: "bold",
                            mb: 4
                        }}>
                        Posts
                    </Typography>
                    <Button
                        variant="contained"
                        style={{boxShadow: "none", height: 40}}
                        onClick={() => setOpen(true)}
                    >
                        Add New Post
                    </Button>
                </Box>
            </Box>
            <Modal
                title={`Add New Post`}
                onClose={() => setOpen(false)}
                open={open}
            >
                <Box sx={style}>
                    <AddPost getPosts={getPosts} setOpen={setOpen} />
                </Box>
            </Modal>
            <Box
                sx={{
                    padding: 2,
                    flexGrow: 1
                }}>
                <Grid container spacing={3}>
                    {posts.map((job: any, index: any) => (
                        <Grid key={index} size={{ xs: 12, sm: 6, md: 4 }}>
                            <Card sx={{height: '100%', boxShadow: "none", border: '1px solid #ededed'}}>
                                <CardContent>
                                    <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                                        {job.title}
                                    </Typography>
                                    <Typography
                                        variant="subtitle1"
                                        sx={{
                                            fontWeight: "bold",
                                            mt: 1
                                        }}>
                                        Description:
                                    </Typography>
                                    <Typography variant="body2" sx={{ mb: 2 }}>
                                        {job.description}
                                    </Typography>
                                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                                        <strong>Location: </strong> {job.location}
                                    </Typography>
                                    <Typography variant="subtitle1" sx={{ mb: 2 }}>
                                        <strong>Date: </strong> {format(job.jobDate , 'dd/MM/yyyy')}
                                    </Typography>
                                    <Box
                                        sx={{
                                            gap: 1,
                                            display: "flex"
                                        }}>
                                        <Button variant="outlined" color="error" onClick={() => deletePost(job.id, job.title)}>
                                            Delete post
                                        </Button>
                                        <Button variant="outlined" onClick={() => goToInterests(job.id)}>View interests</Button>
                                    </Box>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
        </Box>
    );
}

export default JobListings;
